import { useTranslation } from 'react-i18next';
import SectionTitle from './SectionTitle';
import { FaReact, FaMobileAlt, FaJs, FaProjectDiagram, FaFire } from 'react-icons/fa';

const Skills = ({ id }) => {
  const { t } = useTranslation();

  const skills = [
    { icon: <FaReact className="text-5xl" />, key: "react", color: "text-blue-500" },
    { icon: <FaMobileAlt className="text-5xl" />, key: "reactNative", color: "text-blue-400" },
    { icon: <FaJs className="text-5xl" />, key: "javascript", color: "text-yellow-400" },
    { icon: <FaProjectDiagram className="text-5xl" />, key: "redux", color: "text-purple-500" },
    { icon: <FaFire className="text-5xl" />, key: "firebase", color: "text-orange-500" },
  ];

  return (
    <section id={id} className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto transition-colors duration-200" style={{backgroundColor: 'var(--muted)', color: 'var(--foreground)'}}>
      <SectionTitle
        title={t('skills.title')}
        coloredTitle={t('skills.coloredTitle')}
      />

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
        {skills.map((skill, index) => (
          <div key={index} className="skill-item p-6 rounded-xl shadow-md hover:shadow-lg transition duration-300" style={{backgroundColor: 'var(--card)', color: 'var(--card-foreground)'}}>
            <div className={`skill-icon w-16 h-16 mb-4 mx-auto ${skill.color} transition duration-300`}>
              {skill.icon}
            </div>
            <h3 className="text-xl font-semibold text-center mb-2" style={{color: 'var(--card-foreground)'}}>{t(`skills.list.${skill.key}`)}</h3>
            <p className="text-center" style={{color: 'var(--muted-foreground)'}}>{t(`skills.descriptions.${skill.key}`)}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Skills;
